module.exports = __webpack_public_path__ + "img/22_39.47e3aa20.png";